import { useQueryClient } from '@tanstack/react-query';
import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';
import { useAuthStore } from '@/stores/auth-store';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';

function runLogoutSuccessSideEffects(queryClient) {
  useAuthStore.getState().clearSession();
  useFestivalWorkspaceStore.getState().clearFestivalWorkspace();
  queryClient.clear();
  NotificationManager.success('Logout successful', '', 3000);
}

/**
 * Log out via GET `/admin/logout` — clears session, festival workspace, and TanStack Query cache.
 */
export function useLogoutMutation() {
  const queryClient = useQueryClient();

  return useApiMutation(
    () => '/admin/logout',
    'get',
    {},
    {
      onSuccess: () => runLogoutSuccessSideEffects(queryClient),
      onError: () => runLogoutSuccessSideEffects(queryClient),
    },
  );
}
